<template>
    <div class="app-container">
        <el-button type="primary" icon="el-icon-plus" @click.native="newPersonnel">新增维修原因</el-button>
        <!-- 表格 -->
        <el-table :data="tableData" row-key="index" stripe style="width: 100%">
            <el-table-column align="center" type="index" label="序号" width="100"> </el-table-column>
            <el-table-column align="center" prop="name" label="维修原因名称" sortable> </el-table-column>
            <el-table-column align="center" prop="create_time" label="添加时间" sortable> </el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button @click="editTuserItme(scope.row),drawer = true" slot="reference" type="text" size="small" icon="el-icon-edit">修改</el-button>
                    <el-button @click="deleteTuserItme(scope.row)" type="text" size="small" icon="el-icon-delete">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        
        <div v-if="pageData.total > pageData.per_page" class="pageWrap">
            <el-pagination background layout="prev, pager, next" :page-size="pageData.per_page" :total="pageData.total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <!--表单-->
        <el-dialog :title="addTitle" :visible.sync="addSaleShow" :before-close="hideForm" width="1200px" top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="150px">
                <el-form-item label="维修原因名称" prop="name" style="width:90%">
                    <el-input v-model="formData.name" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {apiWhylist,apiWhyupdate,apiWhyupdateSubmit,apiAddsWhyadd,apiWhydelete} from "../../api/views/other";
export default {
    data() {
        return {
            pageData: {
                total: 0,
                per_page: 0,
            },
            tableData: [],
            addSaleShow: false,
            formLoading: false,
            formData: {name:''},
            formRules:{
                name: [{ required: true, message: "请输入维修原因名称", trigger: "blur" }],
            },
            addType: 'add',
            addTitle: '添加维修原因'
        }
    },
    mounted() {

    },
    created:function() {
        this.getList({page:1})
    },
    methods: {
        getList(page){
            apiWhylist(page).then(res => {
                for(let i of res.data) i.create_time = this.formatDate(i.create_time*1000)
                this.pageData = res
                this.tableData = res.data
            })
        },
        newPersonnel(){
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
            this.addType = 'add'
            this.addTitle = '添加维修原因'
            this.addSaleShow = true
        },
        editTuserItme(row){
            const that = this, query = { id: row.id }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
            apiWhyupdate(query).then(res => {
                this.formData = res
            })
            this.addType = 'edit'
            this.addTitle = '编辑维修原因'
            this.addSaleShow = true

        },
        deleteTuserItme(row){
            const that = this
            let data = {
                id: row.id
            }
            this.$confirm('确认删除？', '提示',{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then( async () => {
                await apiWhydelete(data).then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        that.$message({
                            message: res.message,
                            type: "success"
                        });
                    // 刷新列表
                        that.getList({page:1})
                    }else{
                        that.$message({
                            message: res.message, 
                            type: "error"
                        })
                    }
                })
            }).catch(_ => {
                that.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.addSaleShow = !this.addSaleShow;
            this.$emit("onChange",this.addSaleShow)
            this.formLoading = false
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        formSubmit() {
            const that = this, formData = that.formData
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    that.formLoading = true;
                    if(that.addType == 'edit'){
                        apiWhyupdateSubmit({id:formData.id,name:formData.name}).then(response => {
                            this.formLoading = false;
                            console.log(response.code)
                            result(response)
                        })
                    }else{
                        apiAddsWhyadd({name:formData.name}).then(response => {
                            this.formLoading = false;
                            console.log(response.code)
                            result(response)
                        })
                    }
                    function result(response){
                        if (response.code == 0) {
                            that.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            // 刷新表单
                            that.$refs["dataForm"].resetFields();
                            that.addSaleShow = false;
                            that.getList()
                        } else {
                            that.$message({
                                message: response.message,
                                type: "error"
                            });
                        }
                    }
                }
            })
        },
        handleCurrentChange: function(currentPage){
            this.getList({page:currentPage})
        },
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + '-';
            var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
            var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
            var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
            var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
            var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            return YY + MM + DD +" "+hh + mm + ss;
        },
    }
}
</script>
<style>
    .app-container{
        padding-top: 30px;
    }
    
    .pageWrap{
        width: 100%;
        padding: 30px 0;
        text-align: center;
    }
    .dialog-footer{
        width: 100%;
    }
</style>